<template>
  <v-card
    id="encours"
    fluid
  >



    <v-card>
      <v-card-title class="text-subtitle-2 blue darken-3 white--text">
        <v-row align="text-subtitle-2 baseline">
          <v-col cols="12" md="3">
            <span>
              {{ this.ot_encours.name }}
            </span>
          </v-col>
          <v-col cols="12" md="9" align="right">
            <span>
              {{ this.ot_encours.mission }}
            </span>
          </v-col>
        </v-row>
      </v-card-title>
    </v-card>
    <v-card>
                          <v-card-title>NEO-NARVAL </v-card-title>


                          <v-expansion-panels focusable>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                              Calibrations :  

                                <v-chip class="mx-2" :color="c_fla">Flat field: {{n_fla}}</v-chip>
                                <v-chip class="mx-2" :color="c_bia">Bias: {{n_bia}}</v-chip>
                                <v-chip class="mx-2" :color="c_th0">Thorium: {{n_th0}}</v-chip>

                              </v-expansion-panel-header>
                              <v-expansion-panel-content>

                                 



                                  <v-expansion-panels>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                Flat-Fields

                                <v-chip class="mx-2" :color="c_fla">{{n_fla}}</v-chip>

                              </v-expansion-panel-header>
                              <v-expansion-panel-content>

                                <v-card>
                                  <v-data-table
                                    :headers="h_tab_calib_fla"
                                    :items="tab_calib_fla"
                                  >
                                  </v-data-table>
                                </v-card>

    

                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>



                          <v-expansion-panels>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                              Bias : <v-chip class="mx-2" :color="c_bia">{{n_bia}}</v-chip>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-card-text>


                                  <v-card>
                                  <v-data-table
                                    :headers="h_tab_calib_bia"
                                    :items="tab_calib_bia"
                                  >
                                  </v-data-table>
                                </v-card>



                                </v-card-text>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>


                          <v-expansion-panels>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                Thoriums : <v-chip class="mx-2" :color="c_th0">{{n_th0}}</v-chip>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-card-text>


                                  <v-card>
                                  <v-data-table
                                    :headers="h_tab_calib_th0"
                                    :items="tab_calib_th0"
                                  >
                                  </v-data-table>
                                </v-card>

                                </v-card-text>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>


                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>


                          <v-expansion-panels focusable>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                              Observations : <v-chip class="mx-2" :color="c_st0">{{n_st0}}</v-chip>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>

                                 



                                  <v-expansion-panels>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                obs : <v-chip class="mx-2" :color="c_st0">{{n_st0}}</v-chip>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-card-text>
                                  
                                  <v-card>
                                  <v-data-table
                                    :headers="h_tab_obs"
                                    :items="tab_obs"
                                  >
                                  </v-data-table>
                                </v-card>                                  


                                </v-card-text>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>






                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>


                          <v-expansion-panels focusable>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                              Mesures Stabilitée de Néo-Narval : <v-chip class="mx-2" :color="c_mo0">{{n_mo0}}</v-chip>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>

                                 



                                  <v-expansion-panels>
                            <v-expansion-panel>
                              <v-expansion-panel-header>
                                Mesures : <v-chip class="mx-2" :color="c_mo0">{{n_mo0}}</v-chip>
                              </v-expansion-panel-header>
                              <v-expansion-panel-content>
                                <v-card-text>

                                  

                                  <v-card>
                                  <v-data-table
                                    :headers="h_tab_mo0"
                                    :items="tab_mo0"
                                  >
                                  </v-data-table>
                                </v-card>


                                </v-card-text>
                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>





                              </v-expansion-panel-content>
                            </v-expansion-panel>
                          </v-expansion-panels>
 
  
                        </v-card>






  </v-card>
</template>
<script>
import moment from "moment";
import { utc } from "moment/moment";
export default {
  filters: {
    //.as("seconds")
    formatDate: function (value) {
      if (value) {
        return moment(utc(value).format("YYYY-MM-DD HH:mm"));
      } else {
        return " - ";
      }
    },
    formatDuration: function (value) {
      if(value === null){
        return "0";
      }else if(value < 60){
        return moment(utc(parseFloat(value)*1000 ))
        .format("ss[s]");
      }else if(value < 3600){
        return moment(utc(parseFloat(value)*1000 ))
        .format("mm[m] ss[s]");
      }else{
        return moment(utc(parseFloat(value)*1000 ))
        .format("hh[h] mm[m] ss[s]");
      }

    },
  },
    data: () =>({

      n_fla   : 0,
      n_bia   : 0,
      n_th0   : 0,

      n_mo0   : 0,
      n_st0   : 0,

      n_cal_all : 0,

      c_fla   : "green",
      c_bia   : "bleu",
      c_th0   : "orange",

      c_mo0   : "green",
      c_st0   : "green" ,  




      b_NARVAL:false,
      b_SPIP:false,

      tel:{
        lastpos:{"timestamp":"2073-04-01T00:00:00.000Z","st":"12h00m00s","ah":"+6h00m00s","ra":0.0,"dec":0.0,"airmass":0,"telmarche":0,"date":"2073-04-01","time":"00:00:00"},
        targets:[]
      },
      ots :[],
      ot :{},
      og_ot_nuit :{},
      ot_encours :{},

      title: "Encours",
      dialog:"",
      search:"",
      target:{},
      A_Update_targets : null,
      A_local_load : null,

      ot_encours:{},
      objet :"",
      ra:"",
      dec:"",

      instrument : "tbl",

      info_neo_nuit:{},

      h_tab_calib_fla : [
          { text: 'Fichier', value: 'fname' },
          { text: 'Etat', value: 'state' },
          { text: 'Couleur', value: 'state_color' },],tab_calib_fla : [],
      h_tab_calib_bia : [
          { text: 'Fichier', value: 'fname' },
          { text: 'Etat', value: 'state' },
          { text: 'Couleur', value: 'state_color' },],tab_calib_bia : [],
      h_tab_calib_th0 : [
          { text: 'Fichier', value: 'fname' },
          { text: 'Etat', value: 'state' },
          { text: 'Couleur', value: 'state_color' },],tab_calib_th0 : [],
      h_tab_obs : [
          { text: 'Fichier', value: 'fname' },
          { text: 'Etat', value: 'state' },
          { text: 'Couleur', value: 'state_color' },],tab_obs : [],
      h_tab_mo0 : [          
          { text: 'Fichier', value: 'fname' },
          { text: 'Etat', value: 'state' },
          { text: 'Couleur', value: 'state_color' },],tab_mo0 : [],





    }),
    initialize(){

    },
  created(){
    
  },
  beforeMount(){


  },
  mounted(){

    

    this.A_local_load = setInterval(() =>{

      this.info_neo_nuit   = JSON.parse(JSON.stringify(g.info_neo_nuit));

      this.n_fla          = this.info_neo_nuit.calibs.stat.fla;
      this.n_bia          = this.info_neo_nuit.calibs.stat.bia;
      this.n_th0          = this.info_neo_nuit.calibs.stat.th0;
      this.n_st0          = this.info_neo_nuit.obs.stat.st0;
      this.n_mo0          = this.info_neo_nuit.mesures.stat.mo0;


      this.tab_calib_fla  = this.info_neo_nuit.calibs.info.fla;
      this.tab_calib_bia  = this.info_neo_nuit.calibs.info.bia;
      this.tab_calib_th0  = this.info_neo_nuit.calibs.info.th0;

      this.tab_obs  = this.info_neo_nuit.obs.info.st0;
      this.tab_mo0  = this.info_neo_nuit.mesures.info.mo0;





      this.tel            = JSON.parse(JSON.stringify(g.info.tel));
      this.ots            = JSON.parse(JSON.stringify(g.info.ots));
      //this.ot           = JSON.parse(JSON.stringify(g.info.ots[0]));
      this.og_ot_nuit = JSON.parse(JSON.stringify(g.info.og_ot_nuit));
      this.ot_encours = JSON.parse(JSON.stringify(g.info.obs_encours));
      for(var ot_t of this.ots){
        if(this.og_ot_nuit.id_og == ot_t.id_og)this.ot = ot_t;

      }

      this.instrument = this.ot_encours.instrument;

      switch(this.ot_encours.instrument){
        case 'vis':
          this.b_NARVAL = true;
          this.b_SPIP   = false; 
          break;
        case 'all':
          this.b_NARVAL = true;
          this.b_SPIP   = true; 
          break;
        case 'ir':
          this.b_NARVAL = false;
          this.b_SPIP   = true; 
          break;
        default:
          this.b_NARVAL = false;
          this.b_SPIP   = false; 
          break;
      }







    },(500));
  },
  destroyed: function () {
    clearInterval(this.A_Local_load);
  },
  
  methods: {


  }
}
</script>